import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class CookieService {
  private readonly document = inject(DOCUMENT);

  get(name: string): string | null {
    const match = this.document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));

    return match ? decodeURIComponent(match[1]) : null;
  }

  set(name: string, value: string): void {
    // Secure is set unconditionally — browsers treat localhost as a trusted origin,
    // so the flag is respected in all environments without needing an env check.
    this.document.cookie = `${name}=${encodeURIComponent(value)}; SameSite=Strict; path=/; Secure`;
  }

  delete(name: string): void {
    this.document.cookie = `${name}=; Max-Age=0; SameSite=Strict; path=/; Secure`;
  }
}
